import { useMemo, useState } from "react";
import { CustomerPortalFilters } from "./customer-portal-filters";
import { CustomerPortalRow } from "./customer-portal-row";
import {
  filterPortalShops,
  INITIAL_PORTAL_FILTERS,
  type PortalFilters,
  type PortalShop,
} from "./customer-portal-types";

const COLUMNS = [
  { key: "shop", label: "Shop", className: "px-3 py-2" },
  { key: "portal", label: "Portail client", className: "px-3 py-2" },
  { key: "exchanges", label: "Échanges", className: "px-3 py-2 text-center" },
  {
    key: "exchangeCredit",
    label: "Échanges crédit",
    className: "px-3 py-2 text-center",
  },
  { key: "giftCode", label: "Avoirs", className: "px-3 py-2 text-center" },
  { key: "active", label: "Actif", className: "px-3 py-2 text-center" },
];

export function CustomerPortalTab({ shops }: { shops: PortalShop[] }) {
  const [filters, setFilters] = useState<PortalFilters>(INITIAL_PORTAL_FILTERS);

  const filtered = useMemo(
    () => filterPortalShops(shops, filters),
    [shops, filters],
  );

  const newCount = shops.filter((s) => s.isNewCustomerPortalEnabled).length;

  return (
    <div className="space-y-4">
      <CustomerPortalFilters
        filters={filters}
        onChange={setFilters}
        newCount={newCount}
        totalCount={shops.length}
      />

      <div className="overflow-x-auto rounded-lg border bg-background">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/40 text-left text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {COLUMNS.map(({ key, label, className }) => (
                <th key={key} className={className}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((shop) => (
              <CustomerPortalRow key={shop.id} shop={shop} />
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && (
          <div className="px-3 py-8 text-center text-sm text-muted-foreground">
            Aucun shop ne correspond aux filtres.
          </div>
        )}
      </div>
    </div>
  );
}
